module.exports = __webpack_public_path__ + "static/media/bank-first-republic.92a91b11.svg";